import { styled } from "sharedUI/styles";
import tw from "twin.macro";

export const Wrapper = styled.div`
    color: ${p => p.theme.textContextualDark};
    && {
        h1,
        h2,
        h3,
        h4,
        p {
            &:first-child {
                margin-top: unset;
            }
        }

        p,
        li,
        small,
        strong {
            ${tw`text-text-contextual-base text-lg leading-normal`}
        }

        h1,
        h2,
        h3,
        h4 {
            ${tw`text-text-contextual-dark`}
        }

        h1 {
            ${tw`font-extrabold mt-10 mb-8 text-4xl`}
        }

        h2 {
            ${tw`font-extrabold mt-8 mb-6 text-3xl`}
        }

        h3 {
            ${tw`font-bold mt-8 mb-4 text-2xl`}
        }

        h4 {
            ${tw`font-bold mt-4 mb-2 text-xl`}
        }

        p {
            ${tw`mt-5`}
        }

        li > p {
            ${tw`mt-0 inline-block`}
        }

        p > img {
            ${tw`my-8`}
        }

        ol,
        ul {
            ${tw`my-4 space-y-1`}
        }

        a {
            ${tw`text-text-contextual-accent font-medium`}
        }

        blockquote {
            ${tw`my-4 bg-bg-middle p-4 rounded-xl text-text-base`}
        }
    }
`;
